import angular from 'angular'

angular.module('pub.channel_users', []).controller('ChannelUsersCtrl', ChannelUsersCtrl)

/** @ngInject */
function ChannelUsersCtrl($scope, $log, $http, $controller) {
  var vm = this

  $controller('ListCtrl', { $scope: vm })

  vm.parentType = 'channels'
  vm.itemType = 'user_posts'
  vm.childType = null

  vm.adjustPropertiesForJson = function(item) {
    item.l = parseInt(item.l)
  }

  vm.load()
}
